module.exports = __webpack_public_path__ + "static/media/8.8570e9fa.JPG";